<a
  [href]="linkByLanguage.url"
  class="app-link"
  [ngClass]="[customClass]"
  [class.app-link--bold]="linkByLanguage.bold"
  (click)="openUrl(linkByLanguage.url)"
  [attr.data-e2e]="!e2e ? null : e2e + '--a'"
>
  <app-svg-icon
    *ngIf="linkByLanguage.iconName"
    fill="header-login-button-color"
    icon="{{ linkByLanguage.iconName }}"
    size="medium"
  ></app-svg-icon>
  <span *ngIf="isCookieBannerLink; else translateLabel" class="app-link__name">
    {{ link?.name }}
  </span>
  <ng-template #translateLabel>
    <span class="app-link__name">
      {{ link?.name! | translate }}
    </span>
  </ng-template>
</a>
